/**
 * Payment Breakdown display order (lookup 417 keys):
 * New App / base → Background → Endorsements → Military → others → Educator Credit.
 */
export function paymentBreakdownFeeRank(cdRevenueCode: unknown): number {
  const k = cdRevenueCode != null ? String(cdRevenueCode).trim() : '';
  if (['1', '2', '7', '8'].includes(k)) return 0;
  if (k === '6') return 1;
  if (k === '3') return 2;
  if (['5', '9'].includes(k)) return 3;
  if (k === '10') return 5;
  return 4;
}

function toSortableTime(value: unknown): number {
  if (value == null || value === '') return 0;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const t = new Date(value as string | Date).getTime();
  return Number.isFinite(t) ? t : 0;
}

function toSortableId(value: unknown): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Newest payments first; within the same timestamp, fee rank then detail id
 * so equal-date lines follow New App → Background → Endorsements → Military → Credit.
 */
export function comparePaymentBreakdownRows(
  a: {
    transactionDate?: unknown;
    cdRevenueCode?: unknown;
    paymentHistoryId?: unknown;
  },
  b: {
    transactionDate?: unknown;
    cdRevenueCode?: unknown;
    paymentHistoryId?: unknown;
  }
): number {
  const dateDiff = toSortableTime(b.transactionDate) - toSortableTime(a.transactionDate);
  if (dateDiff !== 0) return dateDiff;
  const rankDiff =
    paymentBreakdownFeeRank(a.cdRevenueCode) - paymentBreakdownFeeRank(b.cdRevenueCode);
  if (rankDiff !== 0) return rankDiff;
  return toSortableId(a.paymentHistoryId) - toSortableId(b.paymentHistoryId);
}
